import * as tslib_1 from "tslib";
import { DisplayObjectNode } from "./DisplayObjectNode";
/**
 * Maintains scenegraph heirarchy when collecting nodes
 */
var SceneGraphNode = (function (_super) {
    tslib_1.__extends(SceneGraphNode, _super);
    function SceneGraphNode() {
        var _this = _super.apply(this, arguments) || this;
        _this.isSceneGraphNode = true;
        _this._numNodes = 0;
        _this._pChildNodes = new Array();
        _this._childDepths = new Array();
        _this._numMasks = 0;
        _this._childMasks = new Array();
        return _this;
    }
    /**
     *
     * @param traverser
     */
    SceneGraphNode.prototype.acceptTraverser = function (traverser) {
        //containers nodes are for ordering only, no need to check enterNode or debugVisible
        if (this.numEntities == 0)
            return;
        var i;
        for (i = this._numNodes - 1; i >= 0; i--)
            this._pChildNodes[i].acceptTraverser(traverser);
        for (i = this._numMasks - 1; i >= 0; i--)
            this._childMasks[i].acceptTraverser(traverser);
    };
    /**
     *
     * @param node
     * @internal
     */
    SceneGraphNode.prototype.iAddNode = function (node) {
        node.parent = this;
        if (node._entity.maskMode) {
            this._childMasks.push(node);
            this._numMasks++;
        }
        else {
            var depth = (this._entity != node._entity) ? node._entity._depthID : -16384;
            var len = this._childDepths.length;
            var index = len;
            while (index--)
                if (this._childDepths[index] < depth)
                    break;
            index++;
            if (index < len) {
                this._pChildNodes.splice(index, 0, node);
                this._childDepths.splice(index, 0, depth);
            }
            else {
                this._pChildNodes.push(node);
                this._childDepths.push(depth);
            }
            this._numNodes++;
        }
        var numEntities = node.isSceneGraphNode ? node.numEntities : 1;
        node = this;
        do {
            node.numEntities += numEntities;
        } while ((node = node.parent) != null);
    };
    /**
     *
     * @param node
     * @internal
     */
    SceneGraphNode.prototype.iRemoveNode = function (node) {
        if (node._entity.maskMode) {
            this._childMasks.splice(this._childMasks.indexOf(node), 1);
            this._numMasks--;
        }
        else {
            var index = this._pChildNodes.indexOf(node);
            this._pChildNodes.splice(index, 1);
            this._childDepths.splice(index, 1);
            this._numNodes--;
        }
        var numEntities = node.numEntities;
        node = this;
        do {
            node.numEntities -= numEntities;
        } while ((node = node.parent) != null);
    };
    return SceneGraphNode;
}(DisplayObjectNode));
export { SceneGraphNode };
export default SceneGraphNode;



// WEBPACK FOOTER //
// ../dist/lib/partition/SceneGraphNode.js